import { createSlice } from "@reduxjs/toolkit";
import { handleReduxResponse } from "../helpers/handleReduxResponse";
import { toast } from "react-toastify";

// Load cart state from local storage
const loadState = () => {
  try {
    const serializedState = localStorage.getItem("cart");
    if (serializedState === null) {
      return { items: [] };
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return { items: [] };
  }
};
// Save cart state to local storage
const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem("cart", serializedState);
  } catch (err) {
    // Ignore write errors
  }
};

// Initial state with the type of CartState
const initialState = loadState();

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addItems: (state, action) => {
      if ((action?.payload?.quantity ?? 0) < 1) {
        return;
      }
      let itid;
      const storedata = {
        _id: action?.payload?.product?._id,
        quantity: action.payload.quantity,
      };
      const existingItem = state?.items?.find((item) => {
        return item?._id === action?.payload?.product?._id;
      });
      if (existingItem) {
        itid = existingItem?._id;
        existingItem.quantity = action.payload.quantity;
      } else {
        itid = action?.payload?.product?._id;
        state?.items?.push(storedata);
      }
      saveState(state);

      if (action.payload?.buyNow && !action.payload?.skipRedirect) {
        window.location.href = `/checkout?buynow=${action?.payload?.buyNow}&id=${itid}&quantity=${action?.payload?.quantity}`;
      }
    },

    removeItems: (state, action) => {
      state.items = state?.items.filter(
        (item) => item?._id !== action?.payload?._id
      );
      toast.success("Item removed from cart successfully");
      saveState(state);
    },

    increaseQuantity: (state, action) => {
      const item = state.items.find(
        (item) => item?._id === action?.payload?.product?._id
      );

      if (item) {
        if (item.quantity !== undefined) {
          item.quantity += 1;
        }
        saveState(state);
      }
    },

    decreaseQuantity: (state, action) => {
      const item = state?.items.find(
        (item) => item?._id === action?.payload?.product?._id
      );

      if (item && item.quantity !== undefined && item.quantity > 1) {
        item.quantity -= 1;
        saveState(state);
      }
    },
    clearCart: (state) => {
      state.items = [];
      saveState(state);
    },
  },
});

export const {
  addItems,
  removeItems,
  increaseQuantity,
  decreaseQuantity,
  clearCart,
} = cartSlice.actions;
export const cartReducer = cartSlice.reducer;
